// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"6a8f6ab2","617":"dc2f7a56","787":"55695bd7","815":"eb9dd28c","849":"c465073d"}[chunkId] + ".chunk.js";
};